(function () {
  var SEARCH_DEBOUNCE_MS = 250;
  var SEARCH_MIN_LENGTH = 2;

  function escapeAttrSelector(value) {
    if (typeof value !== 'string') return '';
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(value);
    }
    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function escapeHtml(text) {
    if (text == null) return '';
    var d = document.createElement('div');
    d.textContent = String(text);
    return d.innerHTML;
  }

  /**
   * Supports: #theme-question (single segment), #theme/question (legacy), theme-only #theme
   */
  function parseHubHashForRoot(root) {
    var raw = String(window.location.hash || '').replace(/^#/, '').trim();
    if (!raw) return null;
    try {
      raw = decodeURIComponent(raw);
    } catch (e) {
      /* keep raw */
    }
    if (raw.indexOf('/') !== -1) {
      var parts = raw.split('/').filter(Boolean).map(function (p) {
        try {
          return decodeURIComponent(p);
        } catch (e2) {
          return p;
        }
      });
      return {
        themeHandle: parts[0] || '',
        questionHandle: parts[1] || ''
      };
    }
    var handles = [];
    root.querySelectorAll('[data-shipping-returns-panel]').forEach(function (p) {
      var h = p.getAttribute('data-shipping-returns-panel');
      if (h) handles.push(h);
    });
    handles.sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < handles.length; i++) {
      var th = handles[i];
      if (raw === th) {
        return { themeHandle: th, questionHandle: '' };
      }
      var prefix = th + '-';
      if (raw.indexOf(prefix) === 0) {
        return { themeHandle: th, questionHandle: raw.slice(prefix.length) };
      }
    }
    return { themeHandle: raw, questionHandle: '' };
  }

  /** Single segment: theme or theme-question (readable question handle, e.g. question-1) */
  function setHubHash(themeHandle, questionHandle) {
    var base = window.location.pathname + window.location.search;
    if (!themeHandle) {
      window.history.replaceState(null, '', base);
      return;
    }
    var segment = questionHandle ? String(themeHandle) + '-' + String(questionHandle) : String(themeHandle);
    var next = '#' + encodeURIComponent(segment);
    if (window.location.hash !== next) {
      window.history.replaceState(null, '', base + next);
    }
  }

  function getActiveQuestionHandle(root) {
    var activeRow = root.querySelector('.shipping-returns-hub__question-row--active [data-shipping-returns-question-handle]');
    if (!activeRow) return '';
    return activeRow.getAttribute('data-shipping-returns-question-handle') || '';
  }

  function syncUrlFromState(root) {
    var themeOpen = root.classList.contains('shipping-returns-hub--theme-open');
    var themeHandle = root.dataset.shippingReturnsActiveTheme || '';
    if (!themeOpen || !themeHandle) {
      setHubHash('', '');
      return;
    }
    var questionHandle = '';
    if (root.classList.contains('shipping-returns-hub--question-open')) {
      questionHandle = getActiveQuestionHandle(root);
    }
    setHubHash(themeHandle, questionHandle);
  }

  function openFromHash(root) {
    var route = parseHubHashForRoot(root);
    if (!route || !route.themeHandle) {
      closeTheme(root);
      return;
    }
    var hasThemeTarget =
      root.querySelector('[data-shipping-returns-theme="' + escapeAttrSelector(route.themeHandle) + '"]') ||
      root.querySelector('[data-shipping-returns-panel="' + escapeAttrSelector(route.themeHandle) + '"]');
    if (!hasThemeTarget) return;
    if (route.questionHandle) {
      var thEsc = escapeAttrSelector(route.themeHandle);
      var qhEsc = escapeAttrSelector(route.questionHandle);
      var qBtn = root.querySelector(
        '[data-shipping-returns-question-theme="' +
          thEsc +
          '"][data-shipping-returns-question-handle="' +
          qhEsc +
          '"]'
      );
      if (!qBtn) {
        qBtn = root.querySelector(
          '[data-shipping-returns-question-theme="' +
            thEsc +
            '"][data-shipping-returns-question-slug="' +
            qhEsc +
            '"]'
        );
      }
      if (qBtn) {
        var qId = qBtn.getAttribute('data-shipping-returns-question-open');
        if (qId) {
          openQuestion(root, qId, route.themeHandle);
          return;
        }
      }
    }
    openTheme(root, route.themeHandle);
  }

  function resetSearchPanelLayout(panel) {
    if (!panel) return;
    panel.style.removeProperty('top');
    panel.style.removeProperty('left');
  }

  function positionSearchPanel(root) {
    var input = root.querySelector('[data-shipping-returns-search-input]');
    var panel = root.querySelector('[data-shipping-returns-search-panel]');
    if (!input || !panel || !root.classList.contains('shipping-returns-hub--search-active')) return;
    if (panel.hidden) return;
    var ir = input.getBoundingClientRect();
    var hr = root.getBoundingClientRect();
    panel.style.setProperty('top', Math.max(0, ir.bottom) + 20 /* safe area */ + 'px');
    panel.style.setProperty('left', '0px');
  }

  function refreshSearchBodyScrollLock() {
    var c = 'shipping-returns-hub-search-lock';
    if (document.querySelector('[data-shipping-returns-hub].shipping-returns-hub--search-active')) {
      document.documentElement.classList.add(c);
      document.body.classList.add(c);
    } else {
      document.documentElement.classList.remove(c);
      document.body.classList.remove(c);
    }
  }

  function clearSearchUI(root) {
    root.classList.remove('shipping-returns-hub--search-active');
    var panel = root.querySelector('[data-shipping-returns-search-panel]');
    if (panel) {
      resetSearchPanelLayout(panel);
      panel.hidden = true;
    }
    var resultsEl = root.querySelector('[data-shipping-returns-search-results]');
    if (resultsEl) resultsEl.innerHTML = '';
    var emptyEl = root.querySelector('[data-shipping-returns-search-empty]');
    if (emptyEl) emptyEl.hidden = true;
    var keywordEl = root.querySelector('[data-shipping-returns-search-keyword]');
    if (keywordEl) keywordEl.textContent = '';
    refreshSearchBodyScrollLock();
  }

  function clearSearchState(root) {
    clearSearchUI(root);
    var input = root.querySelector('[data-shipping-returns-search-input]');
    if (input) input.value = '';
    toggleSearchClearButton(root);
  }

  function toggleSearchClearButton(root) {
    var input = root.querySelector('[data-shipping-returns-search-input]');
    var clearBtn = root.querySelector('[data-shipping-returns-search-clear]');
    if (!input || !clearBtn) return;
    clearBtn.hidden = input.value.trim().length === 0;
  }

  function restoreActiveThemePanel(root) {
    if (!root.classList.contains('shipping-returns-hub--theme-open') || !root.dataset.shippingReturnsActiveTheme) return;
    var handle = root.dataset.shippingReturnsActiveTheme;
    root.querySelectorAll('[data-shipping-returns-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-shipping-returns-panel') !== handle;
    });
  }

  function hideSidebarRelatedPanels(root) {
    root.querySelectorAll('[data-shipping-returns-sidebar-related]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function syncSidebarRelatedForQuestion(root) {
    var handle = root.dataset.shippingReturnsActiveTheme;
    if (!handle) {
      hideSidebarRelatedPanels(root);
      return;
    }
    root.querySelectorAll('[data-shipping-returns-sidebar-related]').forEach(function (el) {
      el.hidden = el.getAttribute('data-shipping-returns-sidebar-related') !== handle;
    });
  }

  function syncRelatedQuestionGroups(root) {
    var activeQuestionHandle = getActiveQuestionHandle(root);
    root.querySelectorAll('[data-shipping-returns-sidebar-related]').forEach(function (panel) {
      if (panel.hidden) return;
      panel.querySelectorAll('[data-shipping-returns-related-question]').forEach(function (group) {
        group.hidden = group.getAttribute('data-shipping-returns-related-question') !== activeQuestionHandle;
      });
    });
  }

  function syncSidebarRelatedSlotEmptyState(root) {
    var slot = root.querySelector('.shipping-returns-hub__sidebar-related');
    if (!slot) return;
    var hide = true;
    if (root.classList.contains('shipping-returns-hub--question-open')) {
      var themeHandle = root.dataset.shippingReturnsActiveTheme;
      if (themeHandle) {
        var panel = root.querySelector(
          '[data-shipping-returns-sidebar-related="' + escapeAttrSelector(themeHandle) + '"]'
        );
        if (panel && !panel.hidden) {
          var activeQ = getActiveQuestionHandle(root);
          if (activeQ) {
            var group = panel.querySelector(
              '[data-shipping-returns-related-question="' + escapeAttrSelector(activeQ) + '"]'
            );
            if (group && !group.hidden) {
              hide = group.classList.contains('shipping-returns-hub__related-questions-group--empty');
            }
          }
        }
      }
    }
    slot.classList.toggle('shipping-returns-hub__sidebar-related--empty', hide);
  }

  function closeQuestion(root) {
    var hadQuestionOpen = root.classList.contains('shipping-returns-hub--question-open');
    var fromLandingFrequent = root.dataset.shippingReturnsQuestionFromLanding === 'true';
    var body = root.querySelector('[data-shipping-returns-question-body]');
    var shell = root.querySelector('[data-shipping-returns-question-shell]');
    if (body) body.innerHTML = '';
    if (shell) shell.hidden = true;
    root.classList.remove('shipping-returns-hub--question-open');
    hideSidebarRelatedPanels(root);
    root.querySelectorAll('[data-shipping-returns-related-question]').forEach(function (group) {
      group.hidden = true;
    });
    root.querySelectorAll('.shipping-returns-hub__question-row--active').forEach(function (row) {
      row.classList.remove('shipping-returns-hub__question-row--active');
    });

    if (fromLandingFrequent) {
      delete root.dataset.shippingReturnsQuestionFromLanding;
      root.classList.remove('shipping-returns-hub--theme-open');
      delete root.dataset.shippingReturnsActiveTheme;
      root.querySelectorAll('[data-shipping-returns-theme-grid="main"]').forEach(function (g) {
        g.hidden = false;
      });
    } else if (hadQuestionOpen) {
      restoreActiveThemePanel(root);
    }
    syncUrlFromState(root);
  }

  function openQuestion(root, blockId, themeHandleOpt) {
    if (!blockId) return;
    var templateId = 'shipping-returns-q-' + String(blockId);
    var template = root.querySelector('#' + escapeAttrSelector(templateId));
    var body = root.querySelector('[data-shipping-returns-question-body]');
    var shell = root.querySelector('[data-shipping-returns-question-shell]');
    if (!template || template.tagName !== 'TEMPLATE' || !template.content || !body || !shell) return;

    clearSearchState(root);

    var wasThemeOpen = root.classList.contains('shipping-returns-hub--theme-open');
    if (!wasThemeOpen) {
      root.dataset.shippingReturnsQuestionFromLanding = 'true';
      root.classList.add('shipping-returns-hub--theme-open');
    }
    if (themeHandleOpt) {
      root.dataset.shippingReturnsActiveTheme = themeHandleOpt;
    }

    root.querySelectorAll('[data-shipping-returns-theme-grid="main"]').forEach(function (grid) {
      grid.hidden = true;
    });

    body.innerHTML = '';
    root.querySelectorAll('.shipping-returns-hub__question-row--active').forEach(function (row) {
      row.classList.remove('shipping-returns-hub__question-row--active');
    });

    root.querySelectorAll('[data-shipping-returns-panel]').forEach(function (panel) {
      panel.hidden = true;
    });

    body.appendChild(template.content.cloneNode(true));
    shell.hidden = false;
    root.classList.add('shipping-returns-hub--question-open');
    syncSidebarRelatedForQuestion(root);

    var idEsc = escapeAttrSelector(String(blockId));
    root.querySelectorAll('[data-shipping-returns-question-open="' + idEsc + '"]').forEach(function (btn) {
      var row = btn.closest('.shipping-returns-hub__question-row');
      if (row) row.classList.add('shipping-returns-hub__question-row--active');
    });
    syncRelatedQuestionGroups(root);
    syncSidebarRelatedSlotEmptyState(root);
    syncUrlFromState(root);

    var back = root.querySelector('[data-shipping-returns-question-back]');
    if (back) back.focus();
  }

  function openTheme(root, handle) {
    closeQuestion(root);
    clearSearchState(root);
    delete root.dataset.shippingReturnsQuestionFromLanding;
    root.dataset.shippingReturnsActiveTheme = handle;
    root.classList.add('shipping-returns-hub--theme-open');
    root.querySelectorAll('[data-shipping-returns-theme-grid="main"]').forEach(function (grid) {
      grid.hidden = true;
    });
    root.querySelectorAll('[data-shipping-returns-panel]').forEach(function (panel) {
      var match = panel.getAttribute('data-shipping-returns-panel') === handle;
      panel.hidden = !match;
    });
    var active = root.querySelector('[data-shipping-returns-panel="' + escapeAttrSelector(handle) + '"]');
    if (active) {
      var backBtn = active.querySelector('[data-shipping-returns-back]');
      if (backBtn) backBtn.focus();
    }
    syncUrlFromState(root);
  }

  function closeTheme(root) {
    closeQuestion(root);
    clearSearchState(root);
    delete root.dataset.shippingReturnsActiveTheme;
    delete root.dataset.shippingReturnsQuestionFromLanding;
    root.classList.remove('shipping-returns-hub--theme-open');
    root.querySelectorAll('[data-shipping-returns-theme-grid="main"]').forEach(function (grid) {
      grid.hidden = false;
    });
    root.querySelectorAll('[data-shipping-returns-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
    syncUrlFromState(root);
  }

  function runSearchFilter(root, searchIndex, rawQuery) {
    var panel = root.querySelector('[data-shipping-returns-search-panel]');
    var resultsEl = root.querySelector('[data-shipping-returns-search-results]');
    var emptyEl = root.querySelector('[data-shipping-returns-search-empty]');
    var keywordEl = root.querySelector('[data-shipping-returns-search-keyword]');
    if (!panel || !resultsEl || !emptyEl) return;

    var q = rawQuery.trim();
    if (q.length <= SEARCH_MIN_LENGTH) {
      clearSearchUI(root);
      return;
    }

    var qLower = q.toLowerCase();
    var items = (searchIndex && searchIndex.items) || [];
    console.log('items ', items);
    var matches = items.filter(function (item) {
      var title = (item.title || '').toLowerCase();
      return title.indexOf(qLower) !== -1;
    });

    root.classList.add('shipping-returns-hub--search-active');
    panel.hidden = false;
    resultsEl.innerHTML = '';

    if (keywordEl) keywordEl.textContent = q;

    if (matches.length === 0) {
      emptyEl.hidden = false;
      requestAnimationFrame(function () {
        positionSearchPanel(root);
      });
      refreshSearchBodyScrollLock();
      return;
    }

    emptyEl.hidden = true;
    requestAnimationFrame(function () {
      positionSearchPanel(root);
    });
    matches.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'shipping-returns-hub__search-result';
      btn.setAttribute('role', 'listitem');
      btn.setAttribute('data-shipping-returns-search-result', '');
      btn.setAttribute('data-shipping-returns-search-block-id', String(item.id));
      btn.setAttribute('data-shipping-returns-search-theme', item.themeHandle || '');
      btn.innerHTML =
        '<span class="shipping-returns-hub__search-result-title">' +
        escapeHtml(item.title) +
        '</span><span class="shipping-returns-hub__search-result-theme">' +
        escapeHtml(item.themeLabel || '') +
        '</span>';
      resultsEl.appendChild(btn);
    });
    refreshSearchBodyScrollLock();
  }

  function bindSearchPanelLayoutListeners() {
    if (window.__shippingReturnsSearchLayoutBound) return;
    window.__shippingReturnsSearchLayoutBound = true;
    var layoutTimer;
    function scheduleAllSearchPanelsLayout() {
      clearTimeout(layoutTimer);
      layoutTimer = setTimeout(function () {
        document.querySelectorAll('[data-shipping-returns-hub].shipping-returns-hub--search-active').forEach(positionSearchPanel);
      }, 32);
    }
    window.addEventListener('resize', scheduleAllSearchPanelsLayout);
    window.addEventListener('scroll', scheduleAllSearchPanelsLayout, true);
  }

  function bindHashRouteListener() {
    if (window.__shippingReturnsHashRouteBound) return;
    window.__shippingReturnsHashRouteBound = true;
    window.addEventListener('hashchange', function () {
      document.querySelectorAll('[data-shipping-returns-hub]').forEach(openFromHash);
    });
  }

  function initSearch(root) {
    var sectionId = root.dataset.shippingReturnsSectionId;
    if (!sectionId) return;
    var jsonEl = document.getElementById('shipping-returns-search-json-' + sectionId);
    var input = root.querySelector('[data-shipping-returns-search-input]');
    var clearBtn = root.querySelector('[data-shipping-returns-search-clear]');
    if (!jsonEl || !input) return;

    var searchIndex = { items: [] };
    try {
      searchIndex = JSON.parse(jsonEl.textContent.trim()) || searchIndex;
    } catch (e) {
      searchIndex = { items: [] };
    }

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      toggleSearchClearButton(root);
      var val = input.value;
      debounceTimer = setTimeout(function () {
        runSearchFilter(root, searchIndex, val);
      }, SEARCH_DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        clearTimeout(debounceTimer);
        clearSearchState(root);
        input.blur();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearTimeout(debounceTimer);
        clearSearchState(root);
        input.focus();
      });
    }

    toggleSearchClearButton(root);
    bindSearchPanelLayoutListeners();
  }

  function initHub(root) {
    if (root.dataset.shippingReturnsInitialized === 'true') return;
    root.dataset.shippingReturnsInitialized = 'true';

    initSearch(root);
    bindHashRouteListener();

    root.addEventListener(
      'click',
      function (e) {
        var themeBtn = e.target.closest('[data-shipping-returns-theme]');
        if (themeBtn && root.contains(themeBtn) && !themeBtn.disabled) {
          var handle = themeBtn.getAttribute('data-shipping-returns-theme');
          if (handle) {
            openTheme(root, handle);
          }
          return;
        }

        var searchHit = e.target.closest('[data-shipping-returns-search-result]');
        if (searchHit && root.contains(searchHit)) {
          var id = searchHit.getAttribute('data-shipping-returns-search-block-id');
          var themeH = searchHit.getAttribute('data-shipping-returns-search-theme');
          if (id) {
            openQuestion(root, id, themeH || undefined);
          }
          return;
        }
      },
      true
    );

    root.addEventListener('click', function (e) {
      var unifiedBack = e.target.closest('[data-shipping-returns-back-unified]');
      if (unifiedBack && root.contains(unifiedBack)) {
        if (root.classList.contains('shipping-returns-hub--question-open')) {
          closeQuestion(root);
        } else {
          closeTheme(root);
        }
        return;
      }

      if (e.target.closest('[data-shipping-returns-question-back]') && root.contains(e.target.closest('[data-shipping-returns-question-back]'))) {
        closeQuestion(root);
        return;
      }

      var qOpen = e.target.closest('[data-shipping-returns-question-open]');
      if (qOpen && root.contains(qOpen)) {
        var panel = qOpen.closest('[data-shipping-returns-panel]');
        var sidebarRel = qOpen.closest('[data-shipping-returns-sidebar-related]');
        var frequentPanel = qOpen.closest('[data-shipping-returns-frequent-panel]');
        var fromVisiblePanel = panel && !panel.hidden;
        var fromSidebarRelated =
          sidebarRel &&
          !sidebarRel.hidden &&
          root.classList.contains('shipping-returns-hub--question-open');
        var fromFrequentLanding = frequentPanel && !root.classList.contains('shipping-returns-hub--theme-open');
        if (fromVisiblePanel || fromSidebarRelated || fromFrequentLanding) {
          var id = qOpen.getAttribute('data-shipping-returns-question-open');
          var themeH = qOpen.getAttribute('data-shipping-returns-question-theme');
          openQuestion(root, id, themeH || undefined);
        }
        return;
      }

      if (e.target.closest('[data-shipping-returns-back]') && root.contains(e.target.closest('[data-shipping-returns-back]'))) {
        closeTheme(root);
      }
    });

    openFromHash(root);
  }

  function boot() {
    document.querySelectorAll('[data-shipping-returns-hub]').forEach(initHub);
  }

  if (!window.__shippingReturnsDomBooted) {
    window.__shippingReturnsDomBooted = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.querySelectorAll) return;
    ev.target.querySelectorAll('[data-shipping-returns-hub]').forEach(initHub);
  });
})();
